import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Upload assets to posthog
posthog-cli sourcemap upload --directory ./path/to/assets
`}</code></pre>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`💡 Tip:`}</strong>{` You can use `}<inlineCode parentName="p">{`--delete-after`}</inlineCode>{` option to clean up sourcemaps after uploading them.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      